import type { ReactElement } from 'react';
import { Link } from 'react-router';

/**
 * The way back to the list a page belongs to — one look on every page.
 *
 * Vladimir, 2026-09-24: *"Buttons to go back on the pages looks different, i
 * need them all to look the same for consistency"* — most were a small button,
 * two were a line of grey text.
 */
export function BackLink({ to, children }: { to: string; children: string }): ReactElement {
  return (
    <Link to={to} className="btn btn-sm">
      ← {children}
    </Link>
  );
}
